import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import { useApplicationSuiteContext } from '../contexts/ApplicationSuiteProvider'
import { getMemberPortalUrl } from '../common/utils/memberPortalUrl'
import { Typography } from '@mui/material'
import PublicIcon from '@mui/icons-material/Public'
import Box from '@mui/material/Box'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import AssessmentIcon from '@mui/icons-material/Assessment'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'

interface UpgradeDialogProps {
  open: boolean
  onClose: () => void
  marketplaceSection?: string
}

const UpgradeDialog: React.FC<UpgradeDialogProps> = ({
  open,
  onClose,
  marketplaceSection = 'membership',
}) => {
  const { tradingHouse } = useApplicationSuiteContext()

  const handleClose = () => {
    onClose && onClose()
  }

  function openMarketplace() {
    window.open(
      getMemberPortalUrl(tradingHouse, `/dashboard/marketplace?display=${marketplaceSection}`),
      '_blank'
    )
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle textAlign={'center'}>
        Maximize Your
        <Typography variant={'h6'} color={'primary'} display={'inline'}>
          {' '}
          Strategy Suite{' '}
        </Typography>
        Experience
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Box display={'flex'} flexDirection={'column'} py={2} gap={2}>
            <Box display={'flex'} alignItems={'center'} gap={1}>
              <PublicIcon fontSize={'large'} color="primary" />
              <Box>
                <Typography variant={'body1'} color={'textPrimary'} fontWeight={'bold'}>
                  Showcase:
                </Typography>
                <Typography>{'View and copy winning strategies from members.'}</Typography>
              </Box>
            </Box>

            <Box display={'flex'} alignItems={'center'} gap={1}>
              <AccountTreeIcon fontSize={'large'} color="primary" />
              <Box>
                <Typography variant={'body1'} color={'textPrimary'} fontWeight={'bold'}>
                  Pattern Builder:
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Define your trade entry rules.
                </Typography>
              </Box>
            </Box>

            <Box display={'flex'} alignItems={'center'} gap={1}>
              <AssessmentIcon fontSize={'large'} color="primary" />
              <Box>
                <Typography variant={'body1'} color={'textPrimary'} fontWeight={'bold'}>
                  Backtest:
                </Typography>
                <Typography>Simulate your trading strategy with historical data.</Typography>
              </Box>
            </Box>

            <Box display={'flex'} alignItems={'center'} gap={1}>
              <NotificationsActiveIcon fontSize={'large'} color="primary" />
              <Box>
                <Typography variant={'body1'} color={'textPrimary'} fontWeight={'bold'}>
                  Alerts:
                </Typography>
                <Typography>Get notifications when your pattern's rules are met.</Typography>
              </Box>
            </Box>
          </Box>

          <Box mt={2} p={2} sx={{ backgroundColor: 'action.hover', borderRadius: 1 }}>
            <Typography
              variant={'body1'}
              color={'textPrimary'}
              fontWeight={'bold'}
              textAlign={'center'}
            >
              Access the full power of Strategy Suite
            </Typography>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '16px',
        }}
      >
        <Button onClick={handleClose} color="primary">
          Maybe later
        </Button>
        <Button onClick={openMarketplace} variant={'contained'} color={'primary'}>
          Upgrade
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UpgradeDialog
